"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**Error amistoso para el usuario lanzado por un resource al cual se le aplico el middleware */
class KeaResourceFriendlyError extends Error {
    constructor(tipo, mensaje) {
        super(mensaje);
        this.friendly = true;
        this.tipo = tipo;
    }
}
exports.KeaResourceFriendlyError = KeaResourceFriendlyError;
function isKeaResourceResponse(x) {
    if (typeof x == "object") {
        const y = x;
        return y.datos !== undefined && y.error !== undefined;
    }
    else {
        return false;
    }
}
/**
 * Este middleware lee las respuestas con la forma { datos: JSON, error?:  { tipo, mensaje }  } y devuelve data siempre y cuando error sea null, si error != null,
 * lanza una excepcion de tipo KeaResourceFriendlyError
 */
async function keaResourceMiddleware(request, next) {
    const ret = await next(request);
    if (isKeaResourceResponse(ret)) {
        if (ret.error) {
            throw new KeaResourceFriendlyError(ret.error.tipo, ret.error.message);
        }
        else {
            return ret.datos;
        }
    }
    else {
        throw new Error("El middleware solo soporta respuestas con la forma de kea-resource");
    }
}
exports.keaResourceMiddleware = keaResourceMiddleware;
//# sourceMappingURL=keamiddleware.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kea-resource/dist/http/keamiddleware.js
// module id = 2268
// module chunks = 0